module.exports = __webpack_public_path__ + "img/1568879544.7b5c8252.jpg";